import { z } from 'zod';
export var CancelQuery;
(function (CancelQuery) {
    CancelQuery.cancelQueryParamsSchema = z.object({
        chatId: z.coerce.number(),
        queryIdentifier: z.string(),
    });
})(CancelQuery || (CancelQuery = {}));
